// The Main Object
let Book = {

    pictures : document.querySelectorAll('.gallery-item'),
    images   : document.querySelectorAll('.gallery-image'),
    gallery  : document.querySelector('.gallery'),

    // Init Function
    liftoff : () => {

        Book.moodGalleryAnimation()

    },

    // The Slide/Fade on scroll
    moodGalleryAnimation : () => {

        // If the site uses IE remove the class immediately
        if (!window.IntersectionObserver )
            Book.pictures.forEach(function(image){Book.pictures.classList.remove('hidden')})

        // If the site supports IO do the rest
        if (!!window.IntersectionObserver ){

            // Create the observer
            var observer = new IntersectionObserver((entries, observer) => { 
                
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.remove('hidden');
                        observer.unobserve(entry.target);
                    }
                });

                }, { threshold: [.1] });
            
            Book.pictures.forEach(item => { observer.observe(item) });
        }

        Book.gallery.addEventListener('click' , (event) => {

            if (event.originalTarget == Book.gallery && Book.gallery.classList.contains('active') != null) {

                document.querySelector('.gallery-image.active').classList.toggle('active')
                document.querySelector('.gallery-item.active').classList.toggle('active')
                Book.gallery.classList.remove('active')
                Book.gallery.style.setProperty('--gallery-bg' , 'transparent')
            }



        })

        Book.images.forEach(function(image){
            image.addEventListener('click' , () => {

                // If the parent has the active class we need to clean uo
                if (Book.gallery.classList.contains('active')) {

                    Book.gallery.classList.remove('active')
                    Book.gallery.style.setProperty('--gallery-bg' , 'transparent')
                    image.classList.remove('active')
                    image.parentNode.classList.remove('active')

                } else {
                    let bg = image.dataset.bg;
                    Book.gallery.classList.add('active')
                    Book.gallery.style.setProperty('--gallery-bg' , bg)
                    image.classList.add('active')
                    image.parentNode.classList.add('active')
                }



            })
        })

    },

    // Add Background On Click



}

// Launch The Script
Book.liftoff()